module.exports = __webpack_public_path__ + "img/157.6a69fc3f.jpg";